import axios from "axios";
import React, { useEffect, useRef, useState, useMemo } from "react";
import styled from "styled-components";
import { toast } from "react-toastify";
import { ImArrowLeft, ImArrowRight } from "react-icons/im";


const FormContainer = styled.form`
  width: auto;
  background-color: #f4f4f5;
  display: flex; 
  align-items: flex-start;
  flex-direction: row;
  box-shadow: 0px 0px 2px #ccc;
  padding: 10px;

`;

const DivContainer = styled.form`
  width: 790px;
  background-color: #f4f4f5;
  display: flex; 
  align-items: flex-start;
  flex-direction: column;
  padding: 0px 0px 20px 0px 
`;

const Div = styled.div`
  width:98%;
  background-color: #f4f4f5;
  display: flex; 
  padding: 0px 10px;
  align-items: center;
  gap: 20px 0px;
  flex-direction: row;

`;
const Div3 = styled.div`
  width:25%;
  background-color: #f4f4f5;
  display: flex; 
  padding: 0px 10px;
  align-items: center;
  gap: 20px 10px;
  flex-direction: row;

`;

const Div2 = styled.div`
  width:95%;
  background-color: #f4f4f5;
  display: flex; 
  padding: 10px 10px;
  justify-content: space-between;
  gap: 20px 0px;
  flex-direction: row;
  margin-top: 10px;
`;


const Label = styled.label`
  color: #3a3f42;
  font-weight: bold;
  font-family: 'Open Sans', sans-serif;
  font-size: 20px;
  margin: 0px 5px;

  @media (max-width: 500px) {
    font-size: 16px;
  }
`;
const Td = styled.td`
  word-break: break-word;
  padding-top: 15px;
  padding-bottom: 5px;
  text-align: start;
  width: ${(props) => (props.width ? props.width : "auto")};

  @media (max-width: 768px) {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    padding: 8px 0;
    width: auto;
    &::before {
      content: attr(data-label);
      font-weight: bold;
      color: #333;
      margin-right: 10px;
    }
  }
`;

const Table = styled.table`
  width: 800px;
  background-color: #f4f4f5;
  padding: 5px 20px;
  color: #3a3f42;
  box-shadow: 0px 0px 2px #ccc;
  border-radius: 5px;
  margin-bottom: 10px;
`;

export const Thead = styled.thead``;

export const Tbody = styled.tbody`
  padding-bottom: 05px; 
`;

const Th = styled.th`
  color: #4f4f4f;
  text-align: start;
  border-bottom: inset;
  padding-bottom: 5px;

  @media (max-width: 768px) {
    ${(props) => props.hideOnMobile && "display: none;"}
    display: none; /* Oculta cabeçalhos no layout de cards */
  }
`;

export const TdButton = styled.td`
  font-size: 16px;
  font-weight: bold;
  word-break: break-word;
  padding-top: 15px;
  padding-bottom: 5px;
  cursor: pointer;
`;

const Checkbox = styled.input`
  margin-right: 8px; /* Espaço à direita do checkbox */
`;


const Input = styled.input`
  width: 50%;
  padding: 10px 10px;
  border: 1px solid #ccc; 
  border-radius: 10px;
  height: 30px;
  background-color: #f4f4f5;
  color: #3a3f42;
`;

const Tr = styled.tr`
  text-align: center;

  @media (max-width: 768px) {
    display: flex;
    flex-direction: column;
    background-color: #f9f9f9;
    padding: 15px;
    border-radius: 10px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.15);
    margin-bottom: 10px;
  }
`;
const Button = styled.button`
  cursor: pointer;
  border: none;
  color: black;
  background-color: transparent;
  transition: transform 0.1s;
  &:hover {
    transform: scale(1.3);
  }
`;

const Form = ({ urlApi, usuario, verQuadro, visualizador, fetchCompartilhamento }) => {
  const ref = useRef();

  //--------------------------------------TOKEN-------------------------------------------------------//

  //Token da api
  const token = localStorage.getItem('token');
  const id = parseInt(localStorage.getItem('id'));

  //-------------------------------------------STATE QUE VERIFICA O STATUS DO CHECKBOX-------------------------------------------------------//


  // Estado para armazenar os usuários selecionados
  const [selectedUsers, setSelectedUsers] = useState({});
  // Atualiza os checkboxes com base nos dados recebidos
  useEffect(() => {
    if (!visualizador || !verQuadro.ID_QUADRO) return;

    const initialSelectedUsers = {};
    visualizador.forEach((v) => {
      if (v.ID_QUADRO === verQuadro.ID_QUADRO) {
        initialSelectedUsers[v.COD_FUNCIONARIO] = true;
      }
    });



    setSelectedUsers(initialSelectedUsers);
  }, [visualizador, verQuadro.ID_QUADRO]);

  //----------------------------------------FUNÇÂO QUE INSERE/RETIRA COMPARTILHAMENTO----------------------------------------------------------//
  // Manipula clique no checkbox
  const handleCheckbox = (codFuncionario) => {
    const isSelected = selectedUsers[codFuncionario];

    // Atualiza estado local
    setSelectedUsers((prev) => ({
      ...prev,
      [codFuncionario]: !isSelected,
    }));

    // Dados do usuário
    const usuarioSelecionado = usuario.find(user => user.COD_FUNCIONARIO === codFuncionario);
    const email = usuarioSelecionado?.EMAIL || '';
    const nome = usuarioSelecionado?.NOME || '';

    const data = {
      id_quadro: verQuadro.ID_QUADRO,
      cod_funcionario: codFuncionario,
    };

    if (!isSelected) {
      // Compartilha
      compartilharQuadro(data)
        .then(() => {
          fetchCompartilhamento();
          enviarEmailVisualizador(email, nome);
          toast.success(`Quadro compartilhado com ${nome}!`);
        })
        .catch(console.error);
    } else {
      // Remove compartilhamento
      removerCompartilhamento(data)
        .then(() => {
          fetchCompartilhamento();
          toast.success('Compartilhamento removido com sucesso!');
        })
        .catch(console.error);
    }
  };



  const compartilharQuadro = (data) => {
    return axios.post(`${urlApi}painel-monitoramento/add-compartilhando`, data, {
      headers: { Authorization: `Bearer ${token}` },
    });
  };

  const removerCompartilhamento = (data) => {
    return axios.delete(`${urlApi}painel-monitoramento/delete-compartilhando`, {
      data,
      headers: { Authorization: `Bearer ${token}` },
    });
  };


  //-------------------------------------ENVIA EMAIL-------------------------------------------//

  const enviarEmailVisualizador = (email, nome) => {
    const criador = usuario.find(user => user.COD_FUNCIONARIO === verQuadro.ID_CRIADOR)?.NOME || '';

    axios.get(`${urlApi}painel-monitoramento/compartilhando`, {
      headers: { Authorization: `Bearer ${token}` },
      params: {
        userTo: email,
        criador,
        titulo: verQuadro.TITULO_QUADRO,
        nomeUsuario: nome,
      }
    })
      .then(res => console.log(res.data.message))
      .catch(err => {
        console.error(err.response?.status || err.message);
      });
  };


  const usuariosVisualizadores = useMemo(() => {
    return usuario.filter(user => user.COD_FUNCIONARIO !== id);
  }, [usuario, id]);


  //---------------------------------------------PESQUISAR-----------------------------------------------------------------//

  const [searchTerm, setSearchTerm] = useState('');
  const [filteredUsers, setFilteredUsers] = useState(usuariosVisualizadores);
  const [isLoading, setIsLoading] = useState(true);

  //Input de pesquisa
  const handleSearch = async (term) => {
    setIsLoading(true);

    try {
      const filtered = usuariosVisualizadores.filter((user) => {
        const cracha = (user.COD_FUNCIONARIO || '').toString().toLowerCase();
        const login = (user.LOGON || '').toLowerCase();
        const nome = (user.NOME || '').toLowerCase();


        return (
          cracha.includes(term.toLowerCase()) ||
          login.includes(term.toLowerCase()) ||
          nome.includes(term.toLowerCase())
        );
      });
      setFilteredUsers(filtered);
    } catch (error) {
      console.error(error);
    }
    setCurrentPage(1);
    setIsLoading(false);
  };


  useEffect(() => {
    handleSearch(searchTerm);
  }, [searchTerm, usuariosVisualizadores]);

  //---------------------------------------------ORDENAÇÂO DA PAGINA-----------------------------------------------------------------//
  //Paginação
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;


  // Estado para Ordenação
  const [sortConfig, setSortConfig] = useState(null);

  // Função de Ordenação (agora aplicada ANTES da paginação)
  const sortedData = useMemo(() => {
    let sortableData = [...filteredUsers];

    if (sortConfig !== null) {
      sortableData.sort((a, b) => {
        const aValue = sortConfig.key.split('.').reduce((o, i) => o[i], a);
        const bValue = sortConfig.key.split('.').reduce((o, i) => o[i], b);

        if (aValue < bValue) {
          return sortConfig.direction === "ascending" ? -1 : 1;
        }
        if (aValue > bValue) {
          return sortConfig.direction === "ascending" ? 1 : -1;
        }
        return 0;
      });
    }

    return sortableData;
  }, [filteredUsers, sortConfig]);

  //---------------------------------------EFEITO DE PAGINACAO---------------------------------------------------//

  //Paginação
  // Defina a quantidade de itens por página conforme necessário
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = sortedData.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(sortedData.length / itemsPerPage);
  // Função para ir para a próxima página
  const handleNextPage = () => {
    setCurrentPage((prevPage) => Math.min(prevPage + 1, totalPages));
  };

  // Função para ir para a página anterior
  const handlePrevPage = () => {
    setCurrentPage((prevPage) => Math.max(prevPage - 1, 1));
  };

  // Função para Alterar Ordenação
  const onColumnClick = (key) => {
    let direction = "ascending";

    if (sortConfig && sortConfig.key === key && sortConfig.direction === "ascending") {
      direction = "descending";
    }

    setSortConfig({ key, direction });
    setCurrentPage(1); // Reseta para a primeira página ao ordenar
  };

  // Função para obter a classe CSS da coluna ordenada
  const getSortClass = (key) => {
    return sortConfig?.key === key ? "sorted-column" : "";
  };

  // Função para exibir o ícone de ordenação (▲ ou ▼)
  const getSortIcon = (key) => {
    if (sortConfig?.key !== key) return "↕"; // Ícone neutro quando não ordenado
    return sortConfig.direction === "ascending" ? "▲" : "▼";
  };



  return (
    <div >
      <FormContainer  >

        <DivContainer ref={ref} >
          <Div>
            <Label>Compartilhar quadro com:</Label>
          </Div >
          <Div2>

            <Input
              type="text"
              placeholder="Pesquisar... Ex: crachá, login ou nome"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            <Div3>
              <Button onClick={handlePrevPage} disabled={currentPage === 1} type="button">
                <ImArrowLeft size={20} />
              </Button>
              <span>Página <strong>{currentPage}</strong> de <strong>{totalPages}</strong></span>
              <Button onClick={handleNextPage} disabled={currentPage === totalPages} type="button">
                <ImArrowRight size={20} />
              </Button>
            </Div3>
          </Div2>

          <Div>
            <Table>
              <Thead hideOnMobile>

                <Tr>
                  <Th></Th>
                  <Th onClick={() => onColumnClick("COD_FUNCIONARIO")} className={getSortClass("COD_FUNCIONARIO")}>
                    Crachá: {getSortIcon("COD_FUNCIONARIO")}
                  </Th>
                  <Th onClick={() => onColumnClick("LOGON")} className={getSortClass("LOGON")}>
                    Login: {getSortIcon("LOGON")}
                  </Th>
                  <Th onClick={() => onColumnClick("NOME")} className={getSortClass("NOME")}>
                    Nome: {getSortIcon("NOME")}
                  </Th>
                </Tr>
              </Thead>
              <Tbody>
                {currentItems.map((usuario) => (
                  <Tr key={usuario.COD_FUNCIONARIO}>
                    <Td width="auto">
                      <Checkbox
                        type="checkbox"
                        onChange={() => handleCheckbox(usuario.COD_FUNCIONARIO)}
                        checked={!!selectedUsers[usuario.COD_FUNCIONARIO]}
                      />
                    </Td>
                    <Td width="auto" data-label="Crachá:">{usuario.COD_FUNCIONARIO}</Td>
                    <Td width="auto" data-label="Login:">{usuario.LOGON}</Td>
                    <Td width="auto" data-label="Nome:">{usuario.NOME}</Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
          </Div>


        </DivContainer>
      </FormContainer>
      <style jsx global>{`
      .swal2-container.custom-swal-container {
        z-index: 9999; 
      }
    `}</style>
    </div>

  );
};

export default Form;


